import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";

const UserSheet = ({ isOpen, mode, form, onFieldChange, onClose, onSubmit }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black/60" onClick={onClose}>
        <div className="absolute bottom-0 left-0 right-0 bg-background-400 border-t border-primary-50 rounded-t-2xl px-5 pt-3 pb-10" 
            onClick={e => e.stopPropagation()}>
            
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-white text-base font-semibold">{mode === 'add' ? t('team.new_member') : t('team.edit_member')}</h3>
                <button onClick={onClose}>
                    <IoClose className="text-primary-50 text-xl" />
                </button>
            </div>

            {/* Name */}
            <div className="mb-4">
                <label className="block text-xs text-primary-50 font-mono mb-1.5">NAME</label>
                <input 
                    type='text'
                    placeholder={t('team.name_input_placeholder')}
                    value={form.name}
                    onChange={e => onFieldChange('name')(e.target.value)}
                    className="w-full bg-background-600 text-white border border-primary-50 rounded-xl px-3 py-3 text-sm placeholder:text-primary-10 focus:outline-none 
                    focus:border-secondary-800 focus:ring-1 focus:ring-secondary-800"/>
            </div>
            {/* Telegram ID */}
            <div className="mb-4">
                <label className="block text-xs text-primary-50 font-mono mb-1.5">TELEGRAM ID</label>
                <input 
                    type='number'
                    inputMode='numeric'
                    placeholder="e.g. 123456789"
                    value={form.telegramId}
                    onChange={e => onFieldChange('telegramId')(e.target.value)}
                    className="w-full bg-background-600 text-white border border-primary-50 rounded-xl px-3 py-3 text-sm placeholder:text-primary-10 focus:outline-none 
                    focus:border-secondary-800 focus:ring-1 focus:ring-secondary-800"/>
            </div>
            {/* Is Admin */}
            <div className="flex items-center justify-between mb-4 bg-background-600 rounded-xl px-4 py-3">
                <div>
                    <p className="text-white text-sm font-mono">{t('team.admin_access')}</p>
                    <p className="text-primary-50 text-xs">{t('team.admin_access_desc')}</p>
                </div>
                <div
                    onClick={() => onFieldChange('isAdmin')(!form.isAdmin)}
                    className={`w-12 h-6 rounded-full cursor-pointer transition-colors duration-200 flex items-center px-1 ${
                        form.isAdmin ? 'bg-success-800' : 'bg-primary-50'
                    }`}>
                    <div className={`w-4 h-4 bg-white rounded-full shadow transition-transform duration-200 ${
                        form.isAdmin ? 'translate-x-6' : 'translate-x-0'
                    }`}/>
                </div>
            </div>
            {/* Actions */}
            <div className="flex gap-3">
                <button
                    onClick={onClose}
                    className="flex-1 bg-primary-800 text-primary-50 rounded-xl py-3 text-xs font-mono">
                    {t('general.cancel')}
                </button>
                <button
                    onClick={onSubmit}
                    className="flex-1 bg-secondary-800 text-white rounded-xl py-3 text-xs font-mono font-bold">
                    {mode === 'add' ? t('team.add_member') : t('records.save_changes')}
                </button>
            </div>
        </div>
    </div>
    );
};

export default UserSheet;